<template>
  <div @click="outsideClick" :class="{ active: show }" class="modal-facial-coding">
    <div>
      <div v-if="modal" class="content">
        <h2>Facial Coding advanced settings</h2>
        <div class="radio-wrapper">
          <h3>Do you want the Facial Coding exercise to be:</h3>
          <div>
            <input
              type="radio"
              id="mandatory"
              :value="true"
              v-model="enforce_facialcoding"
            />
            <label for="mandatory">Mandatory</label>
          </div>
          <div>
            <input
              type="radio"
              id="optional"
              :value="false"
              v-model="enforce_facialcoding"
            />
            <label for="optional">Optional</label>
          </div>
          <p>
            * When mandatory, the respondent will not be able to proceed in the survey
            unless they grant access to the webcam.
          </p>
        </div>
        <div class="radio-wrapper" v-if="modal.hasVideo">
          <h3>This question contains video. Please select:</h3>
          <div>
            <input type="radio" id="question" value="question" v-model="facialcoding" />
            <label for="question">Apply Facial Coding to the entire question</label>
          </div>
          <div>
            <input type="radio" id="video" value="video" v-model="facialcoding" />
            <label for="video">Apply Facial Coding only while the video is playing</label>
          </div>
        </div>
        <div class="btns">
          <button @click="apply">Apply</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      show: false,
      facialcoding: 'question',
      enforce_facialcoding: false,
    }
  },
  computed: {
    modal() {
      return this.$store.getters.modalFacialCoding
    },
  },
  watch: {
    modal() {
      if (this.modal) {
        this.openModal()
      }
    },
  },
  methods: {
    ...mapActions(['facialCodingObj', 'modalFacialCoding']),
    apply() {
      this.facialCodingObj({
        question: this.modal.question,
        group: this.modal.group,
        facialcoding: this.facialcoding,
        enforce_facialcoding: this.enforce_facialcoding,
      })
      this.closeModal()
    },
    openModal() {
      this.facialcoding = this.modal.question.advancedOptions.facialcoding
      this.enforce_facialcoding = this.modal.question.advancedOptions.enforce_facialcoding
      this.show = true
    },
    closeModal() {
      this.show = false
      this.modalFacialCoding(null)
    },
    outsideClick(e) {
      if (e.target === document.querySelector('.modal-facial-coding')) {
        this.closeModal()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-facial-coding {
  display: none;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  // z-index: 99998;
  animation: show 0.5s forwards;
  &.active {
    display: flex;
  }
  > div {
    max-width: 600px;
    position: fixed;
    top: 120px;
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.4);
    @include tipography(16);
    color: $main-two;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    // z-index: 999999;
  }
}

.content {
  h2 {
    @include tipography(20);
    font-weight: bold;
    color: $gray-2;
    margin-bottom: 20px;
    margin-top: 10px;
  }
}

.radio-wrapper {
  margin-bottom: 20px;
  h3 {
    @include tipography(16);
    font-weight: bold;
    color: $gray-2;
    margin-bottom: 10px;
  }

  div {
    margin-bottom: 10px;
    label {
      margin-left: 5px;
    }
  }

  p {
    @include tipography(14);
    color: $gray-2;
    margin-top: 10px;
  }
}

.btns {
  display: flex;
  justify-content: flex-end;

  button {
    display: block;
    @include tipography(16);
    background: $blue;
    font-weight: bold;
    padding: 10px 30px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.3s ease;
    text-transform: uppercase;
    &:hover {
      background: $blue-2;
    }
    &:focus {
      outline: none;
    }
  }
}
</style>
